export default [
  {
    path: 'control-sales-team',
    name: 'ControlSalesTeam',
    meta: {
      isDynamic: true,
      id: '控销团队',
      inTab: true
    },
    component: () =>
      import(
        /* webpackChunkName: "SalesmanAndCustomerRelation" */ '@/views/ControlSalesTeamManage/ControlSalesTeam/ControlSalesTeam.vue'
      )
  },
  {
    path: 'batch-control-sales-team',
    name: 'BatchControlSalesTeam',
    meta: {
      id: '新增控销团队',
      title: '新增控销团队',
      inTab: true
    },
    component: () =>
      import(
        /* webpackChunkName: "SalesmanAndCustomerRelation" */ '@/views/ControlSalesTeamManage/ControlSalesTeam/component/BatchAddControlSalesTeamModal.vue'
      )
  },
  {
    path: 'order-audit',
    name: 'OrderAudit',
    meta: {
      inTab: true,
      title: '订单审核'
    },
    component: () =>
      import(
        /* webpackChunkName: "OrderAudit" */ '@/views/ControlSalesTeamManage/OrderAudit/OrderAudit.vue'
      )
  },
  {
    path: 'business-manage',
    name: 'BusinessManage',
    meta: {
      id: '业务管理',
      title: '业务管理',
      inTab: true
    },
    component: () =>
      import(
        /* webpackChunkName: "BusinessManage" */ '@/views/ControlSalesTeamManage/BusinessManage/BusinessManage@3.0.vue'
      )
  }
];
